



























































import { Vue, Component, Prop } from "vue-property-decorator";
import { Isocron, Scouting } from "../../models";
import MeansTypeSelect from "@/components/Isocron/MeansTypeSelect.vue";

export interface IsocronConfiguration {
  isocronMeansType: string;
  isocronType: string;
  isocronRange: number;
}

@Component({ components: { MeansTypeSelect } })
export default class Form extends Vue {
  @Prop({ required: true }) readonly isocronable!: Scouting | Isocron;
  @Prop({ default: false }) readonly editable!: boolean;
  @Prop({ default: false }) readonly loading!: boolean;

  private item = Object.assign(
    {},
    { isocronRange: 15, isocronMeansType: "car", isocronType: "duration" },
    this.isocronable
  );

  get types() {
    return Isocron.types;
  }

  get rangeUm() {
    return Isocron.types.find((o) => o.id === this.item.isocronType)?.um || "-";
  }

  apply() {
    this.$emit("apply", this.item);
  }

  get placeholder() {
    return this.item.isocronType === "duration"
      ? "Inserisci durata"
      : "Inserisci distanza";
  }

  mounted() {
    if (!this.item.isocronType) {
      this.item.isocronType = "distance";
    }
  }

  onTypeSelected(key: string) {
    this.item.isocronType = key;
  }

  set range(key: number) {
    this.item.isocronRange = key;
  }

  get range() {
    return this.item.isocronRange;
  }
}
